import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzLoveBl } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_LOVE_BL: Record<
  Exclude<PageIdWoofzLoveBl, PageIdWoofzLoveBl.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.DOG_SEX_LOVE_BL]: {
    id: PageId.DOG_SEX_LOVE_BL,
    headerId: HeaderId.TITLE_MENU,
  },
  [PageId.DOG_AGE_LOVE_BL]: {
    id: PageId.DOG_AGE_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_LOVE_BL]: {
    id: PageId.URGE_LOVE_BL,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.FEELINGS_LOVE_BL]: {
    id: PageId.FEELINGS_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_1_LOVE_BL]: {
    id: PageId.URGE_1_LOVE_BL,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.TALKING_LOVE_BL]: {
    id: PageId.TALKING_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_FOLLOW_LOVE_BL]: {
    id: PageId.DOG_FOLLOW_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.LICKING_LOVE_BL]: {
    id: PageId.LICKING_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_2_LOVE_BL]: {
    id: PageId.URGE_2_LOVE_BL,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.BEHAVIOR_LOVE_BL]: {
    id: PageId.BEHAVIOR_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.FEEL_GUILTY_LOVE_BL]: {
    id: PageId.FEEL_GUILTY_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_3_LOVE_BL]: {
    id: PageId.URGE_3_LOVE_BL,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.DOG_REACT_LOVE_BL]: {
    id: PageId.DOG_REACT_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.SATISFIED_LOVE_BL]: {
    id: PageId.SATISFIED_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_ISSUES_LOVE_BL]: {
    id: PageId.BEHAVIOR_ISSUES_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.YOUR_REACTION_LOVE_BL]: {
    id: PageId.YOUR_REACTION_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_4_LOVE_BL]: {
    id: PageId.URGE_4_LOVE_BL,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.DOG_BREED_LOVE_BL]: {
    id: PageId.DOG_BREED_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_LOVE_BL]: {
    id: PageId.COMMANDS_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_NAME_LOVE_BL]: {
    id: PageId.DOG_NAME_LOVE_BL,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.LOVE_LOAD_SCREEN_BL]: {
    id: PageId.LOVE_LOAD_SCREEN_BL,
    headerId: HeaderId.TITLE_MENU,
  },
  [PageId.DOG_PROFILE_LOVE_BL]: {
    id: PageId.DOG_PROFILE_LOVE_BL,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.MOTIVATION_LOVE_BL]: {
    id: PageId.MOTIVATION_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.FEEL_DOG_LOVE_BL]: {
    id: PageId.FEEL_DOG_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.FREQUENCY_LOVE_BL]: {
    id: PageId.FREQUENCY_LOVE_BL,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.PREPARE_FLOW_LOVE_BL]: {
    id: PageId.PREPARE_FLOW_LOVE_BL,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.EMAIL_LOVE_BL]: {
    id: PageId.EMAIL_LOVE_BL,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.NEWSLETTER_URGE_LOVE_BL]: {
    id: PageId.NEWSLETTER_URGE_LOVE_BL,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.PERSONALIZED_PLAN_LOVE_BL]: {
    id: PageId.PERSONALIZED_PLAN_LOVE_BL,
    headerId: HeaderId.TITLE_MENU,
  },
  [PageId.LAST_CHANCE_OFFER_LOVE_BL]: {
    id: PageId.LAST_CHANCE_OFFER_LOVE_BL,
  },
  [PageId.SUBSCRIPTIONS_LOVE_BL]: {
    id: PageId.SUBSCRIPTIONS_LOVE_BL,
  },
  [PageId.LAST_CHANCE_OFFER_2_LOVE_BL]: {
    id: PageId.LAST_CHANCE_OFFER_2_LOVE_BL,
  },
  [PageId.CANCEL_OFFER_LOVE_BL]: {
    id: PageId.CANCEL_OFFER_LOVE_BL,
  },
  [PageId.CHAT_UPSELL_LOVE_BL]: {
    id: PageId.CHAT_UPSELL_LOVE_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_LOVE_BL]: {
    id: PageId.UPSELL_LOVE_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_FEEDING_GUIDE_LOVE_BL]: {
    id: PageId.UPSELL_FEEDING_GUIDE_LOVE_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EMOTIONAL_SUPPORT_LOVE_BL]: {
    id: PageId.UPSELL_EMOTIONAL_SUPPORT_LOVE_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_LOVE_BL]: {
    id: PageId.DOWNLOAD_LOVE_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
